export default class HotspotList {
	constructor(config) {
		this.el = config.el || document.querySelectorAll(".hotspot-list");
		this.carouselContainer = this.el.querySelector(
			".hotspot-list__carousel"
		);
		this.thumbs = this.el.querySelector(".carousel__controls");
		this.carouselItems = this.el.querySelectorAll(".js-carousel__item");
		this.id = this.el.getAttribute("id");
		this.links = this.el.querySelectorAll(".js-carousel__item a");
		this.init();
	}

	init() {
		const self = this;

		self.attachEvents();
		this.checkDots();
	}

	attachEvents() {
		const self = this;

		//create carousel navigation
		if (this.carouselItems && this.carouselItems.length > -1) {
			this.carouselItems.forEach((item, index) => {
				var ids = item.getAttribute("id");

				self.thumbs.innerHTML +=
					"<button tabindex='-1' data-id='" +
					ids +
					"' aria-hidden='true' class='controls__dot'></button>";
			});
		}

		//add current class
		var controlDot = document
			.querySelector("#" + this.id)
			.getElementsByClassName("controls__dot");
		if (controlDot && controlDot[0]) {
			var controlDotFirst = controlDot[0];
			controlDotFirst.className += " current__dot";
		}

		//check the current item and update navigation dots
		var timer = null;
		let $this = this;
		this.carouselContainer.addEventListener(
			"scroll",
			event => {
				if (timer !== null) {
					clearTimeout(timer);
				}
				timer = setTimeout(function() {
					let allElems = document
						.querySelector("#" + $this.id)
						.querySelectorAll(".carousel__item");
					let elNav = document
						.querySelector("#" + $this.id)
						.querySelector(".current__dot");
					let setCurrent = true;

					allElems.forEach(obj => {
						if (isElementInViewport(obj)) {
							var elToCurrent = document.querySelector(
								"button[data-id^='" + obj.id + "']"
							);
							let containsCurrent =
								elNav &&
								elNav.classList.contains("current__dot");
							if (containsCurrent && setCurrent) {
								elNav.classList.remove("current__dot");
								elToCurrent.classList.add("current__dot");
								setCurrent = false;
							} else if (setCurrent) {
								elToCurrent.classList.add("current__dot");
								setCurrent = false;
							}
						}
					});
				}, 150);
			},
			false
		);

		// Add button click eventListener
		const dots = this.el.querySelectorAll(".controls__dot");

		for (let i = 0; i < dots.length; i++) {
			dots[i].addEventListener("click", function() {
				var element = document.getElementById(
					this.getAttribute("data-id")
				);
				let currentDot = document
					.querySelector("#" + $this.id)
					.querySelector(".current__dot");

				if (currentDot != null) {
					currentDot.classList.remove("current__dot");
				}

				self.carouselContainer.scrollLeft = element.offsetLeft;
			});
		}

		this.links.forEach(link => {
			link.addEventListener("focus", function(event) {
				self.carouselContainer.scrollLeft = link.parentNode.offsetLeft;
				let scrollTop =
					window.pageYOffset || document.documentElement.scrollTop;
				window.scrollTo(
					0,
					link.parentNode.getBoundingClientRect().top + scrollTop
				);
			});
		});

		window.addEventListener(
			"resize",
			function() {
				self.checkDots();
				self.checkOverlappingElements();
			},
			true
		);

		//verify if element is viewport visible
		function isElementInViewport(el) {
			var rect = el.getBoundingClientRect();

			return (
				rect.bottom > 0 &&
				rect.right > 100 &&
				rect.left <
					(window.innerWidth - 100 ||
						document.documentElement.clientWidth - 100) &&
				rect.top <
					(window.innerHeight ||
						document.documentElement.clientHeight)
			);
		}
	}

	checkDots() {
		let dots = this.el.querySelectorAll(".controls__dot");

		if (dots && dots.length > 0) {
			dots.forEach(element => {
				element.classList.remove("hidden");
			});
			if (window.innerWidth >= 668) {
				// remove last dot when not equal count + 2 visible cards
				if (dots.length > 2) {
					dots[dots.length - 1].classList.add("hidden");
				}
				if (dots.length == 2) {
					dots[dots.length - 1].classList.add("hidden");
					dots[dots.length - 2].classList.add("hidden");
				}
			}
		}
	}

	checkOverlappingElements() {
		let controls = this.el.querySelector(".carousel__controls");
		let title = this.el.querySelector(".section__title");
		if (title && controls) {
			const rect1 = title.getBoundingClientRect();
			const rect2 = controls.getBoundingClientRect();

			if (
				!(
					rect1.right < rect2.left ||
					rect1.left > rect2.right ||
					rect1.bottom < rect2.top ||
					rect1.top > rect2.bottom
				)
			) {
				title.classList.add("mb-xs-2");
				title.classList.add("mb-sm-2");
			} else {
				title.classList.remove("mb-sm-2");
				title.classList.remove("mb-xs-2");
			}
		}
	}
}
